module.exports = __webpack_public_path__ + "static/media/france-3-paca.4e965e4c.png";